function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-905-246H535V824H-905z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#944923"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27 16h13v8.5a6.5 6.5 0 01-6.5 6.5h0a6.5 6.5 0 01-6.5-6.5V16z",
  fill: "#F8DAAE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 11h3a7 7 0 017 7v.26L25 21v-3a7 7 0 017-7z",
  fill: "#FF5C5C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.604 47.022v-6.858c0-3.76 1.768-5.003 5.679-5.003L29.894 32l10.596 3.161c3.912 0 5.51 1.242 5.51 5.003V46",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.878 21.377l11.321-6.19c3.142-.188 5.323-.025 6.544.49 1.83.772 2.383 2.378 1.194 3.352-.793.65-2.39.419-4.79-.691-3.791 2.913-6.715 4.533-8.772 4.859-2.057.326-3.89-.28-5.497-1.82z",
  fill: "#C31616"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.486 17.484c-.207-.137-.732-.14-1.576-.006-.843.134-1.604.536-2.284 1.205"
})), /*#__PURE__*/React.createElement("path", {
  d: "M30 31.5c-3 .59-4.5 2.053-4.5 4.386 0 2.334 1.5 3.538 4.5 3.614l2-3.614 4 3.614c1.667-1 2.5-2.205 2.5-3.614 0-1.409-1.333-2.87-4-4.386H30z",
  fill: "#FFCD78"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.5 22.756l-3.5-1.42v1.393a3.969 3.969 0 002.724 3.769v7.805c.57 1.355 1.944 2.032 4.122 2.032 2.177 0 3.489-.677 3.933-2.032v-3.348",
  fill: "#F8DAAE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.814 22.5V25",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.532 45.642c1.048.174 1.572.644 1.572 1.41 0 .767-.78 1.089-2.339.966.819 1.176.484 2.068-1.005 2.674-2.222.814-4.945.03-8.17-2.353l3.921-.445 1.897-.842 1.996-1.41h2.128z",
  fill: "#F9D8A0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9E0B0B",
  d: "M22.508 42.929l-1.994-1.312v5.23l1.994 1.49z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9D8A0",
  d: "M55.746 43.348H22.41v4.774h33.336z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC5A5A",
  d: "M20.586 41.657h32.73l2.444 1.715H22.606z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M18.68 47.517c0 .938.641 1.398 1.923 1.381.05.859.747 1.65 2.089 2.373 3.83.96 6.856-.085 9.074-3.135h-9.074l-2.09-2.279c-1.28.17-1.922.723-1.922 1.66z",
  fill: "#F9D8A0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

function SvgDelivered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 70 60",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgDelivered;